import {
  Box,
  Button,
  HStack,
  IconButton,
  Text,
  useDisclosure,
} from "@chakra-ui/react"
import { FiX } from "react-icons/fi"
import type { WarehouseLocationTemplateDTO } from "../../../client"
import LocationPickerModal from "../Modals/LocationPickerModal"

type WarehouseLocationPickerProps = {
  value: string
  onChange: (value: string) => void
  template?: WarehouseLocationTemplateDTO | null
  title?: string
  placeholder?: string
  isDisabled?: boolean
  size?: "sm" | "md" | "lg"
}

// Picker for selecting a location code from the active warehouse template.
export function WarehouseLocationPicker({
  value,
  onChange,
  template = null,
  title = "Wybierz lokalizację",
  placeholder = "Wybierz lokalizację z listy",
  isDisabled = false,
  size = "sm",
}: WarehouseLocationPickerProps) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const hasTemplate = Boolean(template)
  const canOpen = hasTemplate && !isDisabled

  return (
    <>
      <HStack align="stretch">
        <Button
          size={size}
          variant="outline"
          onClick={onOpen}
          isDisabled={!canOpen}
          justifyContent="space-between"
          flex="1"
          borderRadius="xl"
        >
          <Box textAlign="left" noOfLines={1}>
            {value.trim() || placeholder}
          </Box>
        </Button>
        <IconButton
          size={size}
          aria-label="Wyczyść lokalizację"
          variant="outline"
          colorScheme="red"
          onClick={() => onChange("")}
          isDisabled={!value.trim()}
          icon={<FiX />}
          borderRadius="xl"
        />
      </HStack>

      <LocationPickerModal
        isOpen={isOpen}
        onClose={onClose}
        template={template}
        title={title}
        onChoose={(code) => {
          onChange(code)
          onClose()
        }}
      />
      {!hasTemplate ? (
        <Text fontSize="xs" color="gray.500" mt={1}>
          Ten magazyn nie ma zdefiniowanego szablonu lokalizacji.
        </Text>
      ) : null}
    </>
  )
}
